// NOTE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// This file must synced with `web-ssr`'s `guessUserAgentInfo`.
// If you change this code, please change there, too.

const DEVICE_TYPES = {
  phone: 'phone',
  phablet: 'phablet',
  tablet: 'tablet',
  desktop: 'desktop',
};

type UserAgentString = string | null | undefined;

const containsAnyUa = (substrings: Array<string>) => (ua: UserAgentString) => {
  // Load testing tools such as ab and autocannon, and Datadog Synthetics
  // (simulated user requests), do not send a user agent string.
  if (typeof ua !== 'string') {
    return false;
  }

  const normalizedUa = ua.toLowerCase();
  return substrings
    .map(substring => substring.toLowerCase())
    .some(substring => normalizedUa.includes(substring));
};

const isTablet = containsAnyUa(['ipad', 'kfapwi']);

const isPhablet = containsAnyUa(['nexus']);

const isMobile = containsAnyUa(['iphone', 'mobile']);

type UserAgentInfo = {
  // Support any values of `DEVICE_TYPES`.
  deviceType: typeof DEVICE_TYPES[keyof typeof DEVICE_TYPES];
  width: number;
};

const guessUserAgentInfo = (userAgent: UserAgentString): UserAgentInfo => {
  // Order is important since subsequent conditions are more generic.
  // Specifically, guessing a tablet looks for specific devices,
  // as does phablet, and then mobile looks for devices or a `mobile`
  // string in the UA. Desktop is the fallback.
  if (isTablet(userAgent)) {
    return { deviceType: DEVICE_TYPES.tablet, width: 660 };
  }
  if (isPhablet(userAgent)) {
    return { deviceType: DEVICE_TYPES.phablet, width: 420 };
  }
  if (isMobile(userAgent)) {
    return { deviceType: DEVICE_TYPES.phone, width: 320 };
  }
  return { deviceType: DEVICE_TYPES.desktop, width: 1024 };
};

export default guessUserAgentInfo;
